import JsonField from './JsonField.js'
import formats from '../../../api/formats'
import forms from '../../common/forms.js'
import people from '../../people'

export default
class PersonDocField extends JsonField {
  getDescription (model) {
    const _f = (v) => v || '-'
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    switch (this.type.toUpperCase()) {
      case 'PASSPORT_RF':
      case 'BIRTH_CERT_RF':
      case 'MARRIAGE_CERT_RF':
        return `${_f(obj.sernum)}`
      case 'PENSION_CERT_RF':
        return `${_f(obj.snils)}`
      case 'DRIVER_LIC_RF':
        return `${_f(obj.number)}`
      case 'TEMPORARY_ID_RF':
        return `Действительно до ${obj.validTo ? formats.formatDate(obj.validTo) : '-'}`
    }
    return ``
  }
  open (model, onChange) {
    let key = this.getCode(model)
    let fstrategy = this.getStrategy()
    this.cxt.getReferencePerson(model, this.name).then((personId) => {
      people.getIndividual(personId).then((person) => {
        fstrategy.setParentProps(person)
        forms.openFormStg(fstrategy, key).then((data) => {
          this.setCode(model, key, onChange)
        })
      })
    })
  }
  select (model, onChange) {
    const getQuery = () => {
      return this.getCode(model) ? this.getCode(model) : ''
    }
    this.cxt.getReferencePerson(model, this.name)
    .then((personId) => {
      return new Promise((resolve, reject) => {
        people.getIndividual(personId).then((person) => {
          let docs = person.docs.filter(d => d.type === this.type)
          if (docs.length > 0) {
            people.selectDocByIndividual(this.cxt.context, person, getQuery, this.type).then((data) => resolve(data))
          } else {
            let fstrategy = this.getStrategy()
            fstrategy.setParentProps(person)
            forms.openFormStg(fstrategy, null).then((data) => {
              resolve([data])
            })
          }
        })
      })
    })
    .then((values) => {
      if (Array.isArray(values) && values.length > 0) {
        this.setCode(model, values[0], onChange)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/PersonDocField.js